const salesChannel = (state = {}, action) => {
  switch (action.type) {
    case "SALES_CHANNEL":
      return { ...state, ...action.payload };
    case "REMOVE_SALES_CHANNEL":
      return {};
    default:
      return state;
  }
};
export default salesChannel;
